import { render, staticRenderFns } from "./TelephonyMatchCard.vue?vue&type=template&id=d7d8264a&scoped=true"
import script from "./TelephonyMatchCard.vue?vue&type=script&lang=ts"
export * from "./TelephonyMatchCard.vue?vue&type=script&lang=ts"
import style0 from "./TelephonyMatchCard.vue?vue&type=style&index=0&id=d7d8264a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d8264a",
  null
  
)

export default component.exports